import React, {Component} from 'react';
import IntakeFormRadTextEnum from "./enum/IntakeFormRadTextEnum";
import FormField from "../../../components/form/FormField";
import {PhoneInput, TextInput} from "../../../components";
import {YesNoRadioInput} from "../public/YesNoRadioInput";
import {Dropdown} from "primereact/dropdown";

class IntakeFormRadContactInformation extends Component {
    render() {
        const {
            selectedLanguage, readOnly, enumLabel, nationalityLabel, onChange, pushFormFieldRef,
            phoneNumber, whatsappNumber, email, address, country, countries, city, postalCode
        } = this.props

        return (
            <div className="container dim14-form-row-align">
                <h3 className="text-center mb-3">
                    <b>{IntakeFormRadTextEnum.Contact_Information[selectedLanguage]}</b>
                </h3>

                {/* Phone Number */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Phone_Number[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : phoneNumber}
                        >
                            <PhoneInput
                                containerClass={
                                    readOnly ? "PhoneInputDisabledBackground" : ""
                                }
                                inputClass="w-100"
                                value={phoneNumber}
                                disabled={readOnly}
                                onChange={(value) => onChange("phoneNumber", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* WhatsApp Usage */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Do_You_Use_This_Number_For_Whatsapp[selectedLanguage]}
                    </div>
                    <div className="col-8">
                        <YesNoRadioInput
                            value={whatsappNumber != null ? "No" : "Yes"}
                            readOnly={readOnly}
                            enumLabel={enumLabel}
                            onValueChange={(value) => {
                                if (value === "Yes") {
                                    onChange("whatsappNumber", null);
                                } else if (value === "No" && whatsappNumber == null) {
                                    onChange("whatsappNumber", "");
                                }
                            }}
                        />
                    </div>
                </div>

                {/* WhatsApp Number Input - Show only when No is selected */}
                {whatsappNumber != null && (
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Whatsapp_Number[selectedLanguage]}:
                        </div>
                        <div className="col-8">
                            <PhoneInput
                                containerClass={
                                    readOnly ? "PhoneInputDisabledBackground" : ""
                                }
                                inputClass="w-100"
                                value={whatsappNumber}
                                disabled={readOnly}
                                onChange={(value) => onChange("whatsappNumber", value)}
                            />
                        </div>
                    </div>
                )}

                {/* Email */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Email[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <TextInput
                            className="w-100"
                            value={email}
                            disabled={readOnly}
                            onChange={(value) => onChange("email", value)}
                        />
                    </div>
                </div>

                {/* Address */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Address[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <TextInput
                            className="w-100"
                            value={address}
                            disabled={readOnly}
                            onChange={(value) => onChange("address", value)}
                        />
                    </div>
                </div>

                {/* Country, City, Postal Code */}
                <div className="row">
                    <div className="col-auto dim14-form-label">
                        {IntakeFormRadTextEnum.Country[selectedLanguage]}:
                    </div>
                    <div className="col-4">
                        <Dropdown
                            className={`DropdownBorderColor w-100 ${
                                readOnly ? "DropdownDisabledBackground" : ""
                            }`}
                            value={country}
                            disabled={readOnly}
                            dataKey={"id"}
                            options={countries}
                            optionLabel={"name"}
                            filter
                            filterLocale={"en-US"}
                            filterBy={"name"}
                            onChange={(event) => onChange("country", event.value)}
                        />
                    </div>
                    <div className="col-auto dim14-form-label">
                        {IntakeFormRadTextEnum.City[selectedLanguage]}:
                    </div>
                    <div className="col">
                        <TextInput
                            className="w-100"
                            value={city}
                            disabled={readOnly}
                            onChange={(value) => onChange("city", value)}
                        />
                    </div>
                    <div className="col-auto dim14-form-label">
                        {IntakeFormRadTextEnum.Postal_Code[selectedLanguage]}:
                    </div>
                    <div className="col">
                        <TextInput
                            className="w-100"
                            value={postalCode}
                            disabled={readOnly}
                            onChange={(value) => onChange("postalCode", value)}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

export default IntakeFormRadContactInformation;